import styled from 'styled-components';
import { Typography } from '@mui/material';
import { ReactComponent as TreeGraphic } from '../../assets/tree-graphic.svg';
import { FlexCenter, FlexColumn } from '../Flex';

const Wrapper = styled(FlexColumn)`
  width: 456px;
  height: 400px;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.palette.common.white};
  border: 1px solid ${({ theme }) => theme.palette.common.gray13};
  padding: 56px;
  gap: 28px;
  border-radius: 8px;
  box-shadow: 0px 16px 250px 0px rgba(0, 0, 0, 0.05);
`;

const ContinueLink = styled.span`
  text-decoration: underline;
  cursor: pointer;
`;

type Props = {
  onContinue: () => void;
};

const SelectDatasetPage = ({ onContinue }: Props) => (
  <FlexCenter
    sx={{
      width: '100%',
      height: '100%',
    }}
  >
    <Wrapper>
      <FlexColumn sx={{ gap: 1, alignItems: 'center', background: 'none' }}>
        <Typography sx={{ fontWeight: 'bold' }}>
          Select a subfolder or filter
        </Typography>
        <Typography sx={{ color: 'common.gray2' }}>
          You are trying to load a large amount of assets.
        </Typography>
      </FlexColumn>
      <TreeGraphic />
      <Typography sx={{ color: 'common.gray2' }}>
        Or{' '}
        <ContinueLink onClick={onContinue}>
          continue to view lineage
        </ContinueLink>
      </Typography>
    </Wrapper>
  </FlexCenter>
);

export default SelectDatasetPage;
